import React, { useState, useEffect, useCallback } from 'react';
import Section from '../../../../forms/section';
import restApiClient from '../../../../services/restApiClient';
import CrudTable from '../../../../components/crudTable';
import FilterTree from '../../../../helpers/filterTree';
import { Container, MoneySettings, Receipt } from './styles';
import ExpenseTypeDialog from '../../../../components/expenseTypeDialog';
import CreateUpdateGroupDialog from '../../../../components/createUpdateGroupDialog';

function SectionTreeView({ history }) {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderby] = useState({ name: 'asc' });
  const [searchBy, setSearchBy] = useState('');
  const [openExpenseTypeDialog, setOpenExpenseTypeDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(undefined);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('expense');
  const [action, setAction] = useState({
    key: '',
    actionLabel: '',
    depthLabel: '',
  });

  const columns = Section.tableSchema;

  const loadSections = useCallback(() => {
    restApiClient.section
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy ? new FilterTree().like('name', searchBy).toString() : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    loadSections();
  }, [rowsPerPage, page, orderBy, searchBy]);

  return (
    <Container>
      <CrudTable
        title={'Cadastro Seção'}
        modelActions={Section.actions}
        columns={columns}
        rows={rows}
        page={page}
        setPage={(page) => setPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
        onOrderByChange={(orderBy) => setOrderby(orderBy)}
        orderBy={orderBy}
        setOrderBy={(value) => setOrderby(value)}
        searchBy={searchBy}
        setSearchBy={(value) => setSearchBy(value)}
        actions={{
          add: {
            onClick: () => {
              setOpen(true);
              setAction({
                key: 'add',
                actionLabel: 'Cadastro',
                depthLabel: 'Origem',
              });
            },
          },
          update: {
            onClick: (sectionId) => {
              setSelectedId(sectionId);
              setOpen(true);
              setAction({
                key: 'edit',
                actionLabel: 'Edição',
                depthLabel: 'Origem',
              });
            },
            allowedActions: [
              [Section.actions.findById, Section.actions.update],
            ],
          },
          link: {
            icon: <Receipt />,
            onClick: (id, depth, actionKey) => {
              setSelectedId(id);
              setType('expense');
              setOpenExpenseTypeDialog(true);
            },
            maxDepth: 2,
            title: 'Vincular a um tipo de despesa',
            allowedActions: [
              [Section.actions.findById, Section.actions.update],
            ],
          },
          linkIncome: {
            icon: <MoneySettings />,
            onClick: (id, depth, actionKey) => {
              setSelectedId(id);
              setType('income');
              setOpenExpenseTypeDialog(true);
            },
            maxDepth: 2,
            title: 'Vincular a um tipo de receita',
            allowedActions: [
              [Section.actions.findById, Section.actions.update],
            ],
          },
          delete: {
            onClick: (sectionId, index) => {
              restApiClient.section.delete(sectionId).then(() => {
                const result = { ...rows };
                if (index > -1) {
                  result.values.splice(index, 1);
                  result.count--;
                }
                setRows(result);
              });
            },
          },
        }}
        customCellRenderers={{
          expenseType: {
            renderer: (field, value) => {
              if (value?.parent?.parent?.parent) {
                return `${value.parent.parent.parent.name} > ${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
              } else if (value?.parent?.parent) {
                return `${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
              } else if (value?.parent) {
                return `${value.parent.name} > ${value.name}`;
              } else {
                return value?.name ?? '-';
              }
            },
          },
          incomeExpenseType: {
            renderer: (field, value) => {
              if (value?.parent?.parent?.parent) {
                return `${value.parent.parent.parent.name} > ${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
              } else if (value?.parent?.parent) {
                return `${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
              } else if (value?.parent) {
                return `${value.parent.name} > ${value.name}`;
              } else {
                return value?.name ?? '-';
              }
            },
          },
        }}
      />

      <ExpenseTypeDialog
        open={openExpenseTypeDialog}
        selectedId={selectedId}
        restModel={restApiClient.section}
        type={type}
        onClose={() => {
          setOpenExpenseTypeDialog(false);
        }}
        onSuccess={() => {
          loadSections();
          setOpenExpenseTypeDialog(false);
        }}
      />

      <CreateUpdateGroupDialog
        open={open}
        restModel={restApiClient.section}
        action={action}
        parentId={selectedId}
        onCancel={() => {
          setOpen(false);
          setSelectedId(undefined);
        }}
        onSuccess={() => {
          loadSections();
          setOpen(false);
        }}
      />
    </Container>
  );
}

export default SectionTreeView;
